import React, {HTMLProps} from 'react';

// Component ----

type FieldHintProps = HTMLProps<HTMLDivElement>

function FieldHint({children, ...props}: FieldHintProps) {
    return (
        <div className="text-xs leading-1 text-gray-500" {...props}>
            {children}
        </div>
    );
}

export default FieldHint;